import { inject, Injectable } from '@angular/core';
import { assert } from '@sama/js-core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WorkspaceConfigService } from '../../shared/misc-services/workspace-config.service';
import { AuthorizationResourceService } from './resources/authorization-resource.service';

export function getAuthorizationPath() {
  return `${environment.authorizationServiceBaseUrl}/v1/check`;
}

export const permissionsToLoad = ['issue_create', 'issue_read'];

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  private authorizationResourceService = inject(AuthorizationResourceService);
  private workspaceConfigService = inject(WorkspaceConfigService);

  private permissions = new Set();

  async load() {
    try {
      const permissions = await lastValueFrom(
        this.authorizationResourceService.checkPermissions$(
          this.workspaceConfigService.projectId.toString(),
          permissionsToLoad,
        ),
      );
      this.permissions = new Set(permissions);
    } catch (error) {
      this.permissions = new Set();
    }
  }

  hasPermission(permission: string) {
    assert(this.permissions, 'Make sure you fetch permissions first');
    return this.permissions.has(permission);
  }
}
